import React from 'react';
import styled from 'styled-components';
import Icon from 'components/Icon';
import { POSIconButton } from './POSButton';

const TicketItemContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 20px;
  padding: 16px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.background?.overlay || 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.02)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? props.theme.colors?.['border-light'] || 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};
  border-radius: 10px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const TicketName = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.primary || '#ffffff'
      : '#000033'};
`;

const TicketPrice = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors?.primary || '#FA4616'};
`;

const QtyControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(0, 0, 0, 0.03)'};
  padding: 4px;
  border-radius: 8px;
`;

const QtyDisplay = styled.span`
  font-size: 16px;
  font-weight: 600;
  min-width: 32px;
  text-align: center;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.primary || '#ffffff'
      : '#000033'};
`;

const MobileRow = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const DesktopControls = styled.div`
  display: contents;

  @media (max-width: 768px) {
    display: none;
  }
`;

/**
 * POSTicketItem - A ticket item row for POS ticket selection
 *
 * @param {Object} props
 * @param {Object} props.ticket - Ticket object with name, price, count
 * @param {Function} props.onAdd - Callback when adding a ticket
 * @param {Function} props.onRemove - Callback when removing a ticket
 */
const POSTicketItem = ({ ticket, onAdd, onRemove }) => {
  const formattedPrice =
    typeof ticket?.price === 'number'
      ? `$${ticket.price.toFixed(2)}`
      : ticket?.price || '$0.00';

  return (
    <TicketItemContainer>
      <TicketName>{ticket?.name}</TicketName>

      {/* Desktop view */}
      <DesktopControls>
        <TicketPrice>{formattedPrice}</TicketPrice>
        <QtyControls>
          <POSIconButton variant="ghost" onClick={onRemove}>
            <Icon icon="trash" size={16} color="currentColor" />
          </POSIconButton>
          <QtyDisplay>{ticket?.count || 0}</QtyDisplay>
          <POSIconButton onClick={onAdd}>+</POSIconButton>
        </QtyControls>
      </DesktopControls>

      {/* Mobile view */}
      <MobileRow>
        <TicketPrice>{formattedPrice}</TicketPrice>
        <QtyControls>
          <POSIconButton variant="ghost" onClick={onRemove}>
            <Icon icon="trash" size={16} color="currentColor" />
          </POSIconButton>
          <QtyDisplay>{ticket?.count || 0}</QtyDisplay>
          <POSIconButton onClick={onAdd}>+</POSIconButton>
        </QtyControls>
      </MobileRow>
    </TicketItemContainer>
  );
};

export default POSTicketItem;
